import { render, staticRenderFns } from "./piaofujinbiLayer.vue?vue&type=template&id=46ad3bc4&scoped=true&"
import script from "./piaofujinbiLayer.vue?vue&type=script&lang=js&"
export * from "./piaofujinbiLayer.vue?vue&type=script&lang=js&"
import style0 from "./piaofujinbiLayer.vue?vue&type=style&index=0&id=46ad3bc4&lang=scss&scoped=true&"
import style1 from "./piaofujinbiLayer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ad3bc4",
  null
  
)

export default component.exports